import { defineComponent as _defineComponent } from 'vue'
import SurfaceApp from '@@/vuecomponents/SurfaceApp.vue'
import { nextTick, onBeforeMount, ref } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Surface',
  setup(__props) {

const isReadyToMount = ref<boolean>(false)

onBeforeMount(async () => {
  // We need an nextTick here to let the pinia and vuex store finish intializing
  // to prevent a race condition where the SurfaceApp mounts but certain states are not yet available
  await nextTick()
  isReadyToMount.value = true
})

return { __sfc: true,isReadyToMount, SurfaceApp }
}

})